module.exports = __webpack_public_path__ + "resource/img/image019Dark.a2366b2d.png";